import { observer } from 'mobx-react-lite'
import CampaignOutlined from '@mui/icons-material/CampaignOutlined'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { useRouterStore } from 'features/main/main-router/org-guard/RouterStore'
import useStore from 'reusable/mobx-store-utils'
import { useAnnouncementStore } from '../AnnouncementStore'
import AnnouncementWorkitemDeprecationStore from './AnnouncementWorkitemDeprecationStore'

export default observer(function AnnouncementWorkitemDeprecation() {
   const routerStore = useRouterStore()
   const announcementStore = useAnnouncementStore()
   const announcementWorkitemDeprecationStore = useStore(sp => new AnnouncementWorkitemDeprecationStore(sp), { routerStore, announcementStore })

   return <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap', rowGap: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
         <CampaignOutlined sx={{ mr: 1, fontSize: '20px', flexShrink: 0 }} />
         Deliver meetings faster and easier using the AI Meeting Workspace.
      </Box>
      <Button variant='outlined' color='primary' size="small" sx={{ ml: 2, whiteSpace: 'nowrap' }} onClick={announcementWorkitemDeprecationStore.tryMeetingsWorkspace}>
         Try Meetings Workspace
      </Button>
   </Box>
})
